import { ThemeUICSSObject, spacing } from '@apia/theme';
import topBox from './topBox';

const withToolbar: ThemeUICSSObject = {
  display: 'flex',
  maxHeight: '100vh',
  flexDirection: 'column',
  maxWidth: 'oneColumn',
  mx: 'auto',
  overflow: 'hidden',
  p: 3,
  pt: 0,

  '.withToolbar__topBox': { ...topBox, py: 3 },

  '.withToolbar__topBox .topBox__heading .topBox__header .topBox__headings': {
    alignItems: 'start',
    flexDirection: 'column',
    gap: 0,
  },

  '.topBox__imageHeader img': {
    borderRadius: '500px',
    overFlow: 'hidden',
  },

  '.withToolbar__section': {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
    overflow: 'hidden',

    '.withToolbar__toolbar': {
      border: '1px solid',
      borderBottom: 'none',
      borderColor: 'palette.border.section',
      boxShadow: 'toolbar',
      position: 'relative',
      zIndex: 'menu',
    },

    '.withToolbar__main': {
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.section',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      overflow: 'auto',
      p: spacing(5),
    },
  },
};

export default withToolbar;
